var map = {
	"./dataForms.js": "./js/Config/dataForms.js",
	"./klijenti.js": "./js/Config/klijenti.js",
	"./pagecontents.js": "./js/Config/pagecontents.js",
	"./pages.js": "./js/Config/pages.js",
	"./reports.js": "./js/Config/reports.js",
	"./users.js": "./js/Config/users.js",
	"./zaposleni.js": "./js/Config/zaposleni.js"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "./js/Config sync recursive .+\\.js$";